
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import cuentas from './lista-buscador-cuentas.vue';
    import resumen from '../resumen/resumen.vue';
    import filtros from './lista-buscador-filtros.vue';
    import listados from './lista-buscador-listados.vue';
    //import sincronizacion from './lista-buscador-sincronizacion.vue';
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            filtros,
            cuentas,
            resumen,
            //seleccion,
            listados,
            //sincronizacion,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }


        public ActivaBusqueda: boolean = false;
        public AlternarBusqueda()
        {
            this.Controlador.Vista.BarraArriba.Abierto = false;
            if ( this.ActivaBusqueda )
            {
                this.Controlador.Vista.BarraArriba.Altura.Espacio = 30;
                this.Busqueda = '';
            } else
            {
                this.Controlador.Vista.BarraArriba.Altura.Espacio = 0;
            }
            this.ActivaBusqueda = !this.ActivaBusqueda;
        }

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async onBusqueda()
        {
            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Buscar();
            }

        }

        public Buscar( forzar?: boolean )
        {
            if ( forzar )
                this.Busqueda = '';
            this.Buscador.Filtros.Busqueda = this.Busqueda;
            this.Buscador.Buscar( 1 );
        }

        AbrirEditarPrecios()
        {
            this.$router.push( '/mercadolibre/publicaciones/precios' );
        }
    }
